import { UserGeneratedDonutGroup } from '../../../constants/user-generated-donut-chart-properties.const';
import { UserGeneratedListGroup } from '../../../constants/user-generated-list-group.const';
import { UserGeneratedWidgetType } from '../../../enums/user-generated-widget-type.enum';
import { BoardConfig } from '../../../interfaces/board-config.interface';
import { UserGeneratedWidgetConfig } from '../../../interfaces/user-generated-widget-config.interface';

const WIDGET_VALUE_RENAMES: ReadonlyMap<
	UserGeneratedWidgetType,
	ReadonlyMap<string, string>
> = new Map([
	[
		UserGeneratedWidgetType.DONUT,
		new Map<string, string>([['workflows', UserGeneratedDonutGroup.ORDERS]]),
	],
	[
		UserGeneratedWidgetType.LIST,
		new Map<string, string>([['canceled_processes', UserGeneratedListGroup.CANCELED_ORDERS]]),
	],
]);

export function normalizeBoards(boards: BoardConfig[]): BoardConfig[] {
	return boards.map((board) => {
		const widgets = board.userGeneratedWidgets;
		if (!widgets?.length) return board;

		let mutated = false;
		const normalized = widgets.map((widget) => {
			const replacement = WIDGET_VALUE_RENAMES.get(widget.type)?.get(
				widget.value as unknown as string
			);
			if (replacement === undefined) return widget;
			mutated = true;
			return { ...widget, value: replacement } as UserGeneratedWidgetConfig;
		});

		return mutated ? { ...board, userGeneratedWidgets: normalized } : board;
	});
}
